import React from 'react';
import styled, { css } from 'styled-components';
import { StyledMarkdown } from '../../components';
export default function UiValueProp({ model }) {
    return (React.createElement(ValueProp, { image: model.content.image },
        React.createElement(StyledMarkdown, null, model.content.content)));
}
const ValueProp = styled.div `
  background-image: url(${(props) => props.image.url});
  background-repeat: no-repeat;
  padding-bottom: 2rem;
  ${(props) => props.image.width &&
    props.image.height &&
    (props.image.url.endsWith('.svg')
        ? css `
          background-size: ${props.image.width}px ${props.image.height}px;
          min-height: ${props.image.height * 1.25}px;
          padding-left: ${props.image.width * 1.25}px;
        `
        : css `
          background-size: ${props.image.width / 2}px
            ${props.image.height / 2}px;
          min-height: ${(props.image.height / 2) * 1.25}px;
          padding-left: ${(props.image.width / 2) * 1.25}px;
        `)}
`;
//# sourceMappingURL=UiValueProp.js.map